import { getChartColor, LEGEND_TEXT_COLOR, } from "../utils/chartConstants";
import { formatNumericValue, getChartDataset, parseNumericValue, resolveLabelAndValueKeys, } from "../../../utils/chartData";
export function buildPieOption(data, useCustomPieLegend, isMobile) {
    var dataset = getChartDataset(data);
    var _a = resolveLabelAndValueKeys(data, dataset), labelKey = _a.labelKey, valueKey = _a.valueKey;
    var pieCenterY = useCustomPieLegend
        ? isMobile
            ? "46%"
            : "48%"
        : isMobile
            ? "31%"
            : "34%";
    var pieRadius = useCustomPieLegend
        ? isMobile
            ? ["36%", "64%"]
            : ["38%", "66%"]
        : isMobile
            ? ["30%", "56%"]
            : ["34%", "60%"];
    return {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(255,255,255,0.96)",
            borderColor: "#ECEEF4",
            borderWidth: 1,
            textStyle: {
                fontFamily: "Montserrat, sans-serif",
                color: "#374151",
                fontSize: 13,
            },
            extraCssText: "box-shadow: 0 4px 20px rgba(0,0,0,0.08); border-radius: 10px;",
            formatter: function (params) {
                return "<strong>".concat(params.name, "</strong><br/><strong>").concat(formatNumericValue(params.value), "</strong> (").concat(formatNumericValue(params.percent), "%)");
            },
        },
        legend: {
            show: !useCustomPieLegend,
            type: "scroll",
            orient: "horizontal",
            bottom: isMobile ? 8 : 10,
            left: isMobile ? "4%" : "5%",
            right: isMobile ? "4%" : "5%",
            height: isMobile ? 110 : 78,
            textStyle: {
                fontFamily: "Montserrat, sans-serif",
                fontSize: isMobile ? 10 : 11,
                color: LEGEND_TEXT_COLOR,
            },
            itemWidth: isMobile ? 10 : 12,
            itemHeight: isMobile ? 10 : 12,
            itemGap: isMobile ? 12 : 16,
            pageIconColor: "#034EA2",
            pageIconInactiveColor: "#D1D5DB",
            pageTextStyle: {
                fontFamily: "Montserrat, sans-serif",
                color: LEGEND_TEXT_COLOR,
            },
        },
        series: [
            {
                type: "pie",
                radius: pieRadius,
                center: ["50%", pieCenterY],
                avoidLabelOverlap: true,
                itemStyle: {
                    borderRadius: 8,
                    borderColor: "#fff",
                    borderWidth: 1,
                },
                label: { show: false },
                emphasis: {
                    label: { show: false },
                    itemStyle: {
                        shadowBlur: 20,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.15)",
                    },
                },
                data: dataset.map(function (item, index) {
                    var _a;
                    return ({
                        name: item[labelKey],
                        value: parseNumericValue((_a = item[valueKey]) !== null && _a !== void 0 ? _a : item.value),
                        itemStyle: {
                            color: getChartColor(String(item[labelKey]), index),
                        },
                    });
                }),
            },
        ],
    };
}
